import React, { Dispatch, SetStateAction } from 'react';
import { useDispatch } from 'react-redux';
import ConfirmModal from '@components/modal/ConfirmModal';
import { postMarkChallengeAsReadyForAssessment } from '@actions/challenges';
import { Challenge } from 'src/types/shared/Challenge';

const ResetAssessmentStatusModal: React.FC<Props> = ({ challenge, setShowModal, groupId }) => {
    const dispatch = useDispatch();

    return (
        <ConfirmModal
            title="Reset Assessment Status"
            description={`Are you sure you want to reset the assessment status for '${challenge.name}'?`}
            closeModal={() => setShowModal(false)}
            handleSubmit={() => {
                dispatch(postMarkChallengeAsReadyForAssessment(challenge.id, true));
                setShowModal(false);
            }}
        />
    );
};

interface Props {
    challenge: Challenge;
    setShowModal: Dispatch<SetStateAction<boolean>>;
    groupId: string;
}

export default ResetAssessmentStatusModal;
